import * as React from 'react';

import * as main from '../../../styles/mainOld.module.scss';
import * as problems from './problems.module.scss';

export const Problems2 = () => {
  return (
    <section className={problems.problems}>
      <div className="container">
        <h2 className={`${problems.problems__title} ${main.mainTitle}`}>
          Важно не просто «знать», а уметь самостоятельно учиться и понимать
        </h2>
        <div className={`row ${problems.problems__row}`}>
          <div className={`col-12 ${problems.problems__col}`}>
            <p className={`${problems.problems__item} ${problems.problems__itemFirst}`}>
              На уроках дают одно, на&nbsp;ЕГЭ спрашивают второе, а&nbsp;в&nbsp;жизни пригодится третье
            </p>
            <p className={`${problems.problems__item} ${problems.problems__itemSecond}`}>
              Ребенок двигается в&nbsp;заданных программой рамках, не&nbsp;расширяя кругозор
            </p>
          </div>
          <div className={`col-12 ${problems.problems__col}`}>
            <p className={`${problems.problems__item} ${problems.problems__itemFirst}`}>
              Ребенок не умеет учиться без нудной зубрежки
            </p>
            <p className={`${problems.problems__item} ${problems.problems__itemSecond}`}>
              Приходится учиться через силу. Получение новых знаний ассоциируется с тяжелым трудом
            </p>
          </div>
          <div className={`col-12 ${problems.problems__col}`}>
            <p className={`${problems.problems__item} ${problems.problems__itemFirst}`}>
              Учебный материал очень абстрактный, его сложно представить
            </p>
            <p className={`${problems.problems__item} ${problems.problems__itemSecond}`}>
              Ребенок с&nbsp;трудом воспринимает материал, ему тяжело понять и&nbsp;запомнить что-либо
            </p>
          </div>
          <div className={`col-12 ${problems.problems__col}`}>
            <p className={`${problems.problems__item} ${problems.problems__itemFirst}`}>
              Учеба занимает солидную часть жизни. Времени на&nbsp;себя и&nbsp;свое развитие не&nbsp;остается
            </p>
            <p className={`${problems.problems__item} ${problems.problems__itemSecond}`}>
              Психика перегревается, и&nbsp;желание развлекаться постепенно вытесняет желание учиться
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
